import React from "react";
import styled from "styled-components";

const Or = (props) => (
  <Wrapper {...props}>
    <span>OR</span>
  </Wrapper>
);

/**
 * styles
 */
const Wrapper = styled.div`
  display: flex;
  position: relative;
  align-items: center;
  justify-content: center;

  &::before {
    left: 0;
    right: 0;
    height: 1px;
    content: " ";
    display: block;
    position: absolute;
    background-color: var(--bs-gray-10);
  }

  span {
    z-index: 1;
    width: 2rem;
    height: 2rem;
    display: flex;
    position: relative;
    border-radius: 50%;
    font-size: 0.75rem;
    align-items: center;
    color: var(--bs-gray);
    justify-content: center;
    background-color: var(--bs-gray-10);
  }
`;

export default Or;
